import styled from "styled-components";

export const Container = styled.div`
    background-color: white;
    padding: 16px;
    min-height: 80vh;
`;
